import React from 'react';
import { FlatList } from 'react-native';
import type { FundProps } from '../../types';
import { Checkbox, Icons } from '../../Components';
import { MarketMakerApi } from '../api';
import { useColors } from '../../constants/useColors';
import { Button, Text, View } from '../../Components/Themed';


type FundSelectorProps = {
    funds:FundProps[],
    selected_fund_id?:string,
    onSelectFund:(f:FundProps) => void,
    onCreateFund:(f:FundProps) => void,
    onEditFund:(f:FundProps) => void
}
const FundSelector = ({ selected_fund_id, funds, onSelectFund, onCreateFund, onEditFund }:FundSelectorProps) => {
    const Colors = useColors();
    const renderFunds = (data:{item:FundProps, index:number}) => {
        const selected = selected_fund_id == data.item.fund_id ? true : false
        return (
            <Button style={{ padding:2, flexDirection:'row', alignItems:'center' }} onPress={() => onSelectFund(data.item)}>
                <Checkbox checked={selected} disabled onSelect={() => console.log('')}/>
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text size={12} weight='bold' theme='h1'>{data.item.name}</Text>
                    <Text style={{ marginTop:3 }} theme='description'>This is a cool fund!</Text>
                </View>
                <Button onPress={() => onEditFund(data.item)}>
                    <Icons.EditIcon size={18} color={Colors.text.action} />
                </Button>
            </Button>
        )
    }
    return (
        <View>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>Select Fund</Text>
                    <Text style={{ marginTop:3 }} theme='description'>Select a fund to populate the dashboard with the funds orders and data</Text>
                </View>
                <Button
                    title='NEW'
                    type='success'
                    onPress={async() => {
                       const new_fund = await MarketMakerApi.createFund('Pending Fund', 100, 'FOR_MONEY');
                       if(!new_fund){ return alert('Unable to process') }
                       onCreateFund(new_fund)
                    }}
                />
            </View>
            <View transparent>
                <FlatList
                    key={'market_selector'}
                    data={funds}
                    renderItem={renderFunds}
                    keyExtractor={(item) => item.fund_id.toString()}
                />
            </View>
        </View>
    )
}

export default FundSelector